import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import DatePicker from "react-datepicker";
import Select from "../common/selectcustom";
//import ChartColumn from './../../components/chart/column';
import ProgressChart from "../chart/progresschart.js";
import ReportCreate from "../chart/reportCreator";
import Piechart from "../chart/piechart.js";
import moment from "moment";
import RenderButton from "../common/button";
import BranchContext from "../context/branch";
import {
  GetYear,
  getReportgroup,
  ReportData,
  getUserAll,
  GetLocationAll,
  getProductgroup,
  getItems,
  downLoadExcel,
} from "../../services/fire";
import { getMonth } from "../../services/month";
import ScrollToTop from "../common/ScrollToTop";
import Renderreport from "./renderreport";
import { toast } from "react-toastify";
import PopupAlert from "./../common/popupAlert";
import jsfiledownload from "js-file-download";
//import {getUserCurrent,getUserCurrentbyArea} from './../../services/facescan';

const Reportregister = (props) => {
  const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());

  const [value, setValue] = useState(14);
  const [total, setTotal] = useState(0);

  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  const [showonscroll, setshowonscroll] = useState(false);
  const [onprocess, setonprocess] = useState(false);
  const [pageSize, setPageSize] = useState(2000);
  const [statusId, setstatusid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reportlist, setreporlist] = useState([]);
  const [reportgroup, setreportgroup] = useState([]);
  const [userlist, setuserlist] = useState([]);
  const [locationlist, setlocationlist] = useState([]);

  const [itemlist, setitemlist] = useState([]);
  const [grouplist, setgrouplist] = useState([]);

  const [reportId, setreportId] = useState("0");
  const [yearlist, setyearlist] = useState([]);
  const [monthlist, setmonthlist] = useState([]);
  const [yearid, setyearid] = useState(0);
  const [userid, setuserid] = useState(0);
  const [groupid, setgroupid] = useState(0);
  const [itemid, setitemid] = useState(0);
  const [locationid, setlocationid] = useState(0);
  const [vLoad, setvLoad] = useState(false);
  const [month, setmonth] = useState(0);
  const [isDownload, setisDownload] = useState(true);
  const [chkDownload, setchkDownload] = useState(true);
  const [search, setSearch] = useState("");
  // const [confirmsearch, setconfirmsearch] = useState("");
  const [name, setname] = useState("");
  const [productTypeId, setProductTypeId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [register, setregister] = useState([]);
  const [endDate, setEndDate] = useState(new Date());
  const [truckid, setruckid] = useState(0);

  const downloadReport = async () => {
    console.log("aa")
    try {
      // if (register.length > 0) {
      // if (isDownload) return;
      const output = await downLoadExcel(
        reportId,
        yearid,
        month,
        locationid,
        itemid,
        groupid,
        userid
      );
      console.log("output",output)
      const { data: result, headers } = output;
 console.log("result",result)
      jsfiledownload(result, headers["x-suggested-filename"] || `report.xlsx`);

     
    } catch (err) {
      toast.error("ผิดพลาด " + err.message);
    }
  };

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetYear();
      //console.log(result)
      if (result.status === "success") {
        setyearlist(result.data.list);
      } else if (
        result.status === "error" &&
        result.message === "invalid token"
      ) {
        const urlGoBack = "logout";
        setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };

    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const result = await getMonth();

      if (result) {
        setmonthlist(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getProductgroup();

      if (result) {
        setgrouplist(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetLocationAll();

      if (result.status === "success") {
        setlocationlist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getItems(locationid, groupid);

      if (result) {
        setitemlist(result);
      }
    };
    loadData();
  }, [currentBranch, locationid, groupid]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await ReportData(reportId.replace(" ",""),yearid,month,0,'');
  //     if (result) {
  //       setreporlist(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch,reportId,yearid,month]);

  const loadData = async () => {
    if (!currentBranch) return;
    const { data: result } = await ReportData(
      reportId.replace(" ", ""),
      yearid,
      month,
      locationid,
      userid,
      groupid,
      itemid
    );
    if (result) {
      setreporlist(result);
    }
  };

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await getReportgroup();
      if (result) {
        setreportgroup(result);
      }
    };
    loadData();
  }, [currentBranch]);

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);
  };
  const handlemonthChange = (event) => {
    setPageNumber(1);
    setmonth(event.currentTarget.value);
  };

  const handleReportIdChange = (event) => {
    setPageNumber(1);
    setreportId(event.currentTarget.value);
  };
  const handleLocationIdChange = (event) => {
    setPageNumber(1);
    setlocationid(event.currentTarget.value);
  };
  const handleGroupIdChange = (event) => {
    // setPageNumber(1);
    setgroupid(event.currentTarget.value);
  };
  const handleItemIdChange = (event) => {
    // setPageNumber(1);
    setitemid(event.currentTarget.value);
  };
  const handleUserIdChange = (event) => {
    setPageNumber(1);
    setuserid(event.currentTarget.value);
  };
  const handleonClick = (event) => {
    if (reportId === "0") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุประเภทรายงาน\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    }
    if (yearid === 0 && reportId !== "R01") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุปี\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    }
    if (month === 0 && reportId !== "R01") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุเดือน\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    }

    setPageSize(1);
    loadData();
  };
  const handlePopupAlertClick = () => {
    setmessageErros({ askAlert: { enable: false, message: "" } });
  };

  //console.log(reportId)

  if (!currentBranch) {
    return <></>;
  }
  return (
    <div className=" container-fluid">
      <PopupAlert
        isOpen={messageErros.askAlert.enable}
        onOk={handlePopupAlertClick}
        message={messageErros.askAlert.message}
      />
      <div className="m-1 d-flex justify-content-center">
        <span
          className="badge badge-pill badge-success"
          style={{ fontSize: "16px" }}
        >
          Report
        </span>
      </div>
      <div className="row">
        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="ประเภทรายงาน"
              data={reportgroup}
              value={reportId}
              textProperty="name"
              valueProperty="_id"
              onChange={handleReportIdChange}
            />
          </div>
        </div>

        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="ปี"
              data={yearlist}
              value={yearid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleyearChange}
            />
          </div>
        </div>
        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="เดือน"
              data={monthlist}
              value={month}
              textProperty="name"
              valueProperty="_id"
              onChange={handlemonthChange}
            />
          </div>
        </div>
        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="พื้นที่"
              data={locationlist}
              value={locationid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleLocationIdChange}
            />
          </div>
        </div>

        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="ประเภท"
              data={grouplist}
              value={groupid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleGroupIdChange}
            />
          </div>
        </div>
        <div className="col-lg-2  col-sm-2 col-xs-12">
          <div className="form-group">
            <Select
              label="ชื่ออุปกรณ์"
              data={itemlist}
              value={itemid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleItemIdChange}
            />
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-auto">
          <button className="btn btn-primary " onClick={handleonClick}>
            ค้นหา
          </button>
        </div>

        <div className="col-auto">
          <button
            onClick={downloadReport}
            disabled={reportId === 0 || reportId === "0" ? true : false}
            className="btn btn-success "
          >
            Download Excel
          </button>
        </div>
      </div>
      <div>
        <ScrollToTop />
      </div>

      <Renderreport list={reportlist} />
    </div>
  );
};

export default Reportregister;
